import useBackButton from "../../hooks/useBackButton";

/**
 * Drop this inside any sheet/overlay JSX to intercept the hardware back
 * button and close the sheet instead of navigating away.
 *
 * Usage:
 *   <div className="hm-sheet-overlay" ...>
 *     <BackButtonTrap onClose={closeSheet} />
 *     ...
 *   </div>
 */
export default function BackButtonTrap({ onClose }) {
  useBackButton(onClose);
  return null;
}
